export const featuredPortfolio = [
    {
        id: 1,
        title: <a href="https://github.com/Vivekananda-S/Tic-Tac-Toe-" style={{color:'white',textDecoration: 'none'}}>Tic Tac Toe</a>,
        img: "https://img.myloview.com/posters/tic-tac-toe-game-400-103608207.jpg",
    },
    {
        id: 2,
        title: <a href="https://github.com/Vivekananda-S/Virtual_Key_Board" style={{color:'white',textDecoration: 'none'}}>Virtual KeyBoard and Mouse</a>,
        img: "https://i.ytimg.com/vi/jzXZVFqEE2I/maxresdefault.jpg",
    },
    {
        id: 3,
        title: <a href="https://github.com/Vivekananda-S/AutoG" style={{color:'white',textDecoration: 'none'}}>AutoG</a>,
        img: "https://static.toiimg.com/thumb/msid-65709572,width-1200,height-900,resizemode-4/.jpg",
    }
];
export const webPortfolio = [
    {
        id: 1,
        title: <a href="https://github.com/Vivekananda-S/Virtual_Key_Board" style={{color:'white',textDecoration: 'none'}}>Virtual KeyBoard and Mouse</a>,
        img: "https://i.ytimg.com/vi/jzXZVFqEE2I/maxresdefault.jpg",
    },
];
export const mobilePortfolio = [
    {
        id: 1,
        title: "Android Unit Converter",
        img: "https://androidkennel.org/wp-content/uploads/2015/10/Unit-Converter-%E2%80%93-2.png",
    },
];